<template>
    <div class="strategy_main" v-if="englishProgramVideo != null">
<!--        <img src="@/assets/backgroundPicture.png" style="{display: none}" class="big_cat_blur_backgroud"/>-->
        <div class="common_background"></div>
        <div id="navigation_title" v-if="!isWeixinBrowser()" class="navigation" :style="{height:getNavCount()+'px'}">
            <div :style="{height:getStateHeight()+'px'}"></div>
            <div class="left" @click="goBack"><i class="icon-thin_back"/></div>
            <div class="clear"></div>
        </div>

        <div v-if="!isWeixinBrowser()" :style="{'padding-top':getNavCount()+'px'}"></div>

        <div class="transition" v-if="showTransition && objEnglishProgramStar!= null" @click="closeTransition">
            <div class="content">
                <div class="content1">
                    <img class="icon" src="@/Images/jili.png"/>
                    <div id="id_star" class="star">
                        <div class="star_item" v-for="index of parseInt(objEnglishProgramStar.starCount)" :key="index"><img :id="'id_star_' + index"  src="../../Images/jili_star.png"/></div>
                    </div>
                    <div id="id_star_count" class="text">
                        <span>获得{{objEnglishProgramStar.starCount}}颗星</span>
                    </div>
                </div>
            </div>
            <div class="wrapper2">
                <div class="wrapper">
                    <div class="wrapper_replay2">
                        <div class="wrapper_replay" v-on:click.stop="replayClick">
                            <span>Replay</span>
                            <img src="../../Images/xunhuan.png"/>
                        </div>
                    </div>
                    <div class="lesson_action_j">
                        <div class="carding" v-on:click.stop="playGameClick">
                            <img src="../../assets/lesson_game.png"/>
                            <span>玩游戏</span>
                        </div>
                        <div class="learn_word" v-on:click.stop="WordClick">
                            <img src="../../assets/lesson_vocabulary.png"/>
                            <span>词汇</span>
                        </div>
                        <div class="explain" v-on:click.stop="childDialogueClick">
                            <img src="../../assets/lesson_child_dialog.png"/>
                            <span>亲子对话</span>
                        </div>
                        <div class="explain" v-on:click.stop="childDevelopmentClick">
                            <img src="../../assets/lesson_expand.png"/>
                            <span>拓展</span>
                        </div>
                        <div class="clear"></div>
                    </div>
                    <div class="wrapper_close"><img src="@/assets/card_close.png"/></div>
                </div>
            </div>
            <audio class="audio" :src="greatAudio" id="great_audio"/>
        </div>

        <div class="main_content" ref="mainContent">
            <div class='video_content'>
                <video-player class="video-player vjs-custom-skin"
                              ref="videoPlayer"
                              :playsinline="true"
                              :options="playerOptions"
                              :events="events"
                              @play="onPlayerPlay($event)"
                              @ended="onPlayerEnded($event)"
                              @fullscreenchange="onPlayerFullScreenchange($event)">
                </video-player>
            </div>
        </div>

    </div>
</template>

<script>
    import {MessageBox} from "mint-ui";
    import { videoPlayer } from 'vue-video-player'
    import 'vue-video-player/src/custom-theme.css'
    import 'video.js/dist/video-js.css'
    import $ from "jquery";

    export default {
        components: {
            videoPlayer
        },
        data() {
            return {
                type: 0,
                lessonId: 0,
                englishProgramVideo: null,
                isFullScreen: false,
                events: ['fullscreenchange'],
                showTransition: false,
                playerOptions: {
                    //播放速度
                    playbackRates: [0.5, 1.0, 1.5, 2.0],
                    //如果true,浏览器准备好时开始回放。
                    autoplay: true,
                    // 默认情况下将会消除任何音频。
                    muted: false,
                    // 导致视频一结束就重新开始。
                    loop: false,
                    // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
                    preload: 'auto',
                    language: 'zh-CN',
                    // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
                    aspectRatio: '16:9',
                    // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
                    fluid: true,
                    sources: [{
                        //类型
                        type: "video/mp4",
                        //url地址
                        src: ''
                    }],
                    //你的封面地址
                    poster: '',
                    //允许覆盖Video.js无法播放媒体源时显示的默认信息。
                    notSupportedMessage: '此视频暂无法播放，请稍后再试',
                    controlBar: {
                        timeDivider: true,
                        durationDisplay: true,
                        remainingTimeDisplay: false,
                        //全屏按钮
                        fullscreenToggle: true
                    }
                },
                objEnglishProgramStar: null,
                greatAudio:"https://img.xiaohuasheng.cn/great.mp3"
            }
        },
        methods: {
            closePage: function () {
                this.showTransition = false;
                this.$router.go(-1);
            },
            playGameClick: function () {
                let that = this;
                if (that.mustBuy()) {
                    return;
                }

                this.showTransition = false;
                this.$router.replace({name: "PDropQuestion", query: {lessonId: this.lessonId}});
            },
            WordClick: function () {
                let that = this;
                if (that.mustBuy()) {
                    return;
                }

                this.showTransition = false;
                this.$router.replace({name: "PCoreWord", query: {lessonId: this.lessonId}});
            },
            childDialogueClick: function () {
                let that = this;
                if (that.mustBuy()) {
                    return;
                }

                this.showTransition = false;
                this.$router.replace({name: "PDialogue", query: {lessonId: this.lessonId}});
            },
            childDevelopmentClick: function () {
                let that = this;
                if (that.mustBuy()) {
                    return;
                }

                this.showTransition = false;
                this.$router.replace({name: "PExpansion", query: {lessonId: this.lessonId}});
            },
            replayClick: function () {
                this.showTransition = false;
                // 重播
                let vVideo = this.$refs.videoPlayer.player;

                if (vVideo != null) {
                    vVideo.play();
                }
            },
            getStateHeight: function () {
                return this.isWeixinBrowser() ? 15 : this.getCount(this.$store.state.statusheight);
            },
            getNavCount: function () {
                return this.getStateHeight() + 44;
            },
            closeTransition() {
                this.closePage();
            },
            onPlayerPlay: function (e) {
                //此方法不可以在异步方法中执行
                if (e.requestFullscreen) {
                    e.requestFullscreen();
                } else if(e.mozRequestFullScreen) {
                    e.mozRequestFullScreen();
                } else if(e.msRequestFullscreen) {
                    e.msRequestFullscreen();
                } else if(e.oRequestFullscreen) {
                    e.oRequestFullscreen();
                } else if(e.webkitRequestFullscreen) {
                    e.webkitRequestFullScreen();
                }
            },
            onPlayerEnded: function (e) {
                if (e.exitFullscreen){
                    e.exitFullscreen();
                } else if (e.webkitExitFullscreen) {
                    e.webkitExitFullscreen()
                }
            },
            getEnglishProgramStar() {
                // 类型（1看视频/绘本/2录音/3做游戏）
                let that = this;
                let url = "englishProgram/getEnglishProgramStar/" + that.lessonId + "/1";
                this.$axios.get(url).then((response) => {
                    window.console.log(JSON.stringify(response.data))
                    that.objEnglishProgramStar = response.data;
                    let vStarCount = that.getCount(that.objEnglishProgramStar.starCount);

                    if (vStarCount > 0) {
                        that.showTransition = true;

                        setTimeout(() => {
                            that.showReplayAnimate();

                            const greatAudio = document.getElementById('great_audio');
                            greatAudio.play();

                            for(let i = 1; i <= vStarCount; i++) {
                                $("#id_star_" + i).show(300 + i*500, function(){});
                            }
                        }, 200);
                    }
                }).catch(function (error) {
                    window.console.log(error)
                });
            },
            mustBuy: function() {
                let that = this;
                let isBuy = that.objEnglishProgramStar.isBuy;
                let freeTrial = that.objEnglishProgramStar.freeTrial;

                if (isBuy === 0 && freeTrial === 0) {
                    MessageBox.confirm('', {
                        message: ' ',
                        title: '要先购买才能上课哦～快去购买吧！',
                        showConfirmButton:false,
                        showCancelButton:true,
                        closeOnClickModal: false,
                        cancelButtonClass:'cancelButton',
                        confirmButtonClass:'confirmButton',
                        cancelButtonText:'知道了'
                    });
                    return true;
                }

                return false;
            },
            showReplayAnimate:function () {
                let that = this;

                $(".wrapper_replay").animate({height:"44px", width:"154px"},500,function(){
                    $(".wrapper_replay").animate({height:"40px", width:"150px"} ,500, that.showReplayAnimate);
                });
            },
            onPlayerFullScreenchange: function (e) {
                let that = this;

                if (e.isFullscreen() && !that.isFullScreen) {
                    that.isFullScreen = true;
                }

                if (!e.isFullscreen() && that.isFullScreen) {
                    that.isFullScreen = false;
                   // history.go(-1);
                }
            },
            judgePlatform: function () {
                let that = this;
                // 平台（0-其它平台 1-微信IOS平台 2-微信android平台 3-app平台IOS平台 4-app平台android平台）
                let Platform = 0;
                let token = that.$store.state.token;
                let userid = that.$store.state.userid.toString();

                if (that.isWeixinBrowser()) {
                    // 微信平台
                    if (that.isAppIos()) {
                        Platform = 1;
                    } else {
                        Platform = 2;
                    }
                } else if (!that.isEmpty(token) && !that.isEmpty(userid) && token.length > userid.length) {
                    // app平台
                    if (that.isAppIos()) {
                        Platform = 3;
                    } else {
                        Platform = 4;
                    }
                } else {
                    Platform = 0;
                }

                return Platform;
            },
            stopOtherAudio: function () {
                let that = this;
                let vPlatform = that.judgePlatform();

                if (vPlatform === 3) {
                    document.location = "readingclubapp:stopOtherAudio";
                }

                if (vPlatform === 4) {
                    window.note.stopOtherAudio();
                }
            },
        },
        beforeCreate() {
            let vLessonId = parseInt(this.$route.query.lessonId);
            let url = "englishProgram/getLessonHomeInfo/" + vLessonId;
            let that = this;
            this.$axios.get(url).then((response) => {
                that.lessonId = vLessonId;
                that.englishProgramVideo = response.data;

                let vedioUrl = that.$qiNiuDomainBase + that.englishProgramVideo.explanationVideo;
                that.playerOptions.poster = vedioUrl + "?vframe/jpg/offset/5";
                that.playerOptions.sources[0].src = vedioUrl;

                setTimeout(function () {
                    that.stopOtherAudio();
                    // $(".vjs-fullscreen-control").click();
                }, 200);
            }).catch(function (error) {
                window.console.log(error)
            });
        },
        activated() {
            window.scrollTo(0, 0);
        }
    }
</script>

<style scoped>
    .strategy_main {
        position: absolute;
        width: 100%;
        height: auto;
        min-height: 100%;
    }

    .main_content {
        position: absolute;
        width: 100%;
        height: calc(100vmax - 100px);
        display: flex;
        align-items: center;
    }

    .video_content {
        display: inline-block;
        width: 100%;
        overflow: hidden;
        background: white;
    }

    .transition {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.85);
        z-index: 1001;
    }

    .transition .content {
        position: relative;
        height: calc(100% - 44px - 80px - 60px - 25px - 85px - 40px);
        background-color: transparent;
        text-align: center;
        z-index: 1000;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .transition .content1 {
        display: block;
    }

    .transition .content .icon {
        margin-top: 60px;
        margin-bottom: 10px;
        width: 60%;
    }

    .transition .content .text {
        width: 100%;
        margin-top: 5px;
    }

    .transition .content .star {
        height: 35px;
    }

    .transition .content .star .star_item {
        width: 35px;
        height: 35px;
        display: inline-block;
        position: relative;
    }

    .transition .content .star .star_item img {
        width: 35px;
        height: 35px;
        display: none;
        position: absolute;
        left:50%;
        top: 50%;
        -webkit-transform: translateX(-50%) translateY(-50%);
    }

    .transition .content span {
        width: 100%;
        color: white;
        font-size: 12px;
    }

    .transition .wrapper2 {
        position: absolute;
        right: 0;
        bottom: 0;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .transition .wrapper {
        width: 100%;
        text-align: center;
    }
    .transition .wrapper .wrapper_replay2 {
        /*position: absolute;*/
        /*left: 50%;*/
        /*-webkit-transform: translateX(-50%);*/
        top: 0;
        width: 100%;
        height: 44px;
        margin-bottom: 80px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .transition .wrapper .wrapper_replay {
        display: inline-block;
        width: 150px;
        height: 40px;
        text-align: center;
        border-radius: 20px;
        -webkit-border-radius: 20px;
        -moz-border-radius: 20px;
        background-color: #3b9c55;
    }
    .transition .wrapper_close {
        /*position: absolute;*/
        /*bottom: 20px;*/
        left: 0;
        right: 0;
        text-align: center;
        margin-top: 50px;
        margin-bottom: 35px;
    }
    .transition .wrapper_close img {
        width: 40px;
        height: 40px;
    }
    .transition .wrapper_replay span {
        display: inline-block;
        font-size: 20px;
        color: white;
        height: 40px;
        line-height: 40px;
        text-align: center;
        vertical-align: middle;
    }
    .transition .wrapper_replay img {
        display: inline-block;
        width: 27px;
        vertical-align: middle;
        margin-left: 8px;
    }
    .transition .lesson_action_j {
        width: 100%;
    }
    .transition .lesson_action_j img {
        width: 60px;
    }
    .transition .lesson_action_j span {
        display: block;
        color: #FAFAFA;
        font-size: 13px;
        font-weight: bold;
    }
    .transition .lesson_action_j .learn_word {
        float: left;
        width: calc(100%/4);
        text-align: center;
    }
    .transition .lesson_action_j .carding {
        float: left;
        width: calc(100%/4);
        text-align: center;
    }
    .transition .lesson_action_j .explain {
        float: left;
        width: calc(100%/4);
        text-align: center;
    }
</style>
